module.exports = __webpack_public_path__ + "static/media/naomi-woods-icon.f61a740f.jpg";